import { styled } from '@porsche-code/kado-styled-system/jsx';

export const ContentWrapper = styled('div', {
  base: {
    paddingLeft: '4.2rem',
    paddingRight: '4.2rem',

    '@media print': {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
});

export const Page = styled('div', {
  base: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
});

export const Main = styled('main', {
  base: {
    flex: '1 0 auto',
    position: 'relative',
    paddingBottom: '2xl',
  },
});
